import {observer} from 'mobx-react-lite'
import React from 'react'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {CommonStateSettingsContent} from '@components/sticker/my-stickers/board-stickers/sticker-settings/common-state-settings-content-props'
import {CommonProps} from '@components/sticker/my-stickers/board-stickers/sticker-settings/sticker-settings-content'
import {useStickerEditorStore} from '@components/sticker/my-stickers/sticker-editor/sticker-editor-store'
import {noDefaultState} from './use-common-handlers'
import {getPlaceholder} from './utils/get-placeholder'

export const StringStickerSettingsContent = observer((props: CommonProps) => {
  const [editorState] = useStickerEditorStore()
  const {sticker} = props

  const placeholder = getPlaceholder(sticker.properties.stickerType)
  const options: OptionsItem[] = editorState.stringStates.map(x => ({
    text: x.name,
    key: x.id
  }))
  options.unshift({text: placeholder, key: noDefaultState})

  return (
    <CommonStateSettingsContent
      {...props}
      options={options}
      placeholder={placeholder}
    />
  )
})
